import {
  STATUS_ICON_CHECK_O,
  STATUS_ICON_LOADING,
  STATUS_ICON_TIMES_O,
  STATUS_ICON_INACTIVE,
  STATUS_ICON_CLOCK
} from '@/common/utils/statuses';
import computedLocale from '@/common/utils/computedLocale';
import i18n from '@/common/i18n';

export const MIGRATION_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'migrating',
  REPLICATING: 'replicating',
  REPLICATED: 'replicated',
  DEPLOYING: 'deploying',
  DEPLOYED: 'deployed',
  COMPLETED: 'completed',
  FAILED: 'failed',
  CANCELLED: 'cancelled'
} as const;

export type MigrationStatus = typeof MIGRATION_STATUS[keyof typeof MIGRATION_STATUS];

export const MIGRATION_STATUS_TEXT = computedLocale<Record<MigrationStatus, string>>(() => ({
  [MIGRATION_STATUS.PENDING]: i18n.t('Pending'),
  [MIGRATION_STATUS.IN_PROGRESS]: i18n.t('In progress'),
  [MIGRATION_STATUS.REPLICATING]: i18n.t('Replicating'),
  [MIGRATION_STATUS.REPLICATED]: i18n.t('Replicated'),
  [MIGRATION_STATUS.DEPLOYING]: i18n.t('Deploying'),
  [MIGRATION_STATUS.DEPLOYED]: i18n.t('Deployed'),
  [MIGRATION_STATUS.COMPLETED]: i18n.t('Completed'),
  [MIGRATION_STATUS.FAILED]: i18n.t('Failed'),
  [MIGRATION_STATUS.CANCELLED]: i18n.t('Canceled')
}));

export const MIGRATION_STATUS_ICON: Record<MigrationStatus, string> = {
  [MIGRATION_STATUS.PENDING]: STATUS_ICON_CLOCK,
  [MIGRATION_STATUS.IN_PROGRESS]: STATUS_ICON_LOADING,
  [MIGRATION_STATUS.REPLICATING]: STATUS_ICON_LOADING,
  [MIGRATION_STATUS.REPLICATED]: STATUS_ICON_CHECK_O,
  [MIGRATION_STATUS.DEPLOYING]: STATUS_ICON_LOADING,
  [MIGRATION_STATUS.DEPLOYED]: STATUS_ICON_CHECK_O,
  [MIGRATION_STATUS.COMPLETED]: STATUS_ICON_CHECK_O,
  [MIGRATION_STATUS.FAILED]: STATUS_ICON_TIMES_O,
  [MIGRATION_STATUS.CANCELLED]: STATUS_ICON_INACTIVE
};

export const MIGRATION_DISK_BUS_OPTIONS = [
  { value: 'scsi', label: 'SCSI' },
  { value: 'ide', label: 'IDE' },
  { value: 'virtio', label: 'VirtIO' }
] as const;

export const MIGRATION_DISK_BUS_LABELS: Record<string, string> = Object.fromEntries(
  MIGRATION_DISK_BUS_OPTIONS.map(({ value, label }) => [value, label])
);

export const MIGRATION_STATUS_NORMALIZE: Record<string, MigrationStatus> = {
  UNEXECUTED: MIGRATION_STATUS.PENDING,
  [MIGRATION_STATUS.PENDING]: MIGRATION_STATUS.PENDING,
  RUNNING: MIGRATION_STATUS.IN_PROGRESS,
  [MIGRATION_STATUS.IN_PROGRESS]: MIGRATION_STATUS.IN_PROGRESS,
  REPLICATING: MIGRATION_STATUS.REPLICATING,
  [MIGRATION_STATUS.REPLICATING]: MIGRATION_STATUS.REPLICATING,
  REPLICATED: MIGRATION_STATUS.REPLICATED,
  [MIGRATION_STATUS.REPLICATED]: MIGRATION_STATUS.REPLICATED,
  DEPLOYING: MIGRATION_STATUS.DEPLOYING,
  [MIGRATION_STATUS.DEPLOYING]: MIGRATION_STATUS.DEPLOYING,
  DEPLOYED: MIGRATION_STATUS.DEPLOYED,
  [MIGRATION_STATUS.DEPLOYED]: MIGRATION_STATUS.DEPLOYED,
  COMPLETED: MIGRATION_STATUS.COMPLETED,
  [MIGRATION_STATUS.COMPLETED]: MIGRATION_STATUS.COMPLETED,
  ERROR: MIGRATION_STATUS.FAILED,
  [MIGRATION_STATUS.FAILED]: MIGRATION_STATUS.FAILED,
  CANCELED: MIGRATION_STATUS.CANCELLED,
  CANCELLED: MIGRATION_STATUS.CANCELLED,
  [MIGRATION_STATUS.CANCELLED]: MIGRATION_STATUS.CANCELLED
};
